<template>
  <!-- 银行卡支付 -->
  <div>
    <Modal
      v-model="isShowPay"
      class="address-modal"
      @on-cancel="cancel"
      width="550"
    >
      <div>
        <div class="mt10">
          <div>
            <div
              class="pay_channel_wrapper pay_channel_wrapper_un"
              v-for="(item, index) in payCardList"
              :key="index"
            >
              <div class="pay_channel float_clear">
                <div
                  class="fl pay_channel_icon icons icons_channel_unselect pointer_g"
                >
                  <input
                    type="radio"
                    name="payway"
                    :id="'pay' + index"
                    :value="item.id"
                    @click="checkCard(item, index)"
                  />
                  <label :for="'pay' + index" class="pointer_g"></label>
                </div>
                <div class="float_clear">
                  <div class="pay_channel_type fl">
                    <span class="pointer_g">
                      <img :src="item.bankLogoUrl" class="pay_channel_logo" />
                      <strong>{{ item.bankName }}</strong>
                      <strong style="margin-left: 8px" v-show="item.id !== 0">
                        {{ item.acctType == "debit" ? "储蓄卡" : "信用卡" }}
                      </strong>
                      <strong
                        style="margin-left: 8px"
                        v-show="item.sliceCard && item.id !== 0"
                        >尾号({{ item.sliceCard }})</strong
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="payConfim">确认</Button>
      </div>
    </Modal>
    <pay-card-pass-word
      v-if="isShowPayCardModal"
      :isShowPayCardModal.sync="isShowPayCardModal"
      :cusTraceNo="cusTraceNo"
      @getCode="getCode"
    ></pay-card-pass-word>
  </div>
</template>
<script>
import { getCardList } from "api/user.js";
import { doPay } from "api/order";
import payCardPassWord from "./payCardPassWord";
export default {
  name: "payListModal",
  props: {
    isShowPayModal: [Boolean],
    businessCentre: [String],
    orderSns: [String],
  },
  data() {
    return {
      isShowPay: this.isShowPayModal,
      isShowPayCardModal: false,
      checkedValue: '', //选中值
      payCardList: [
        {
          bankLogoUrl: require("../../../assets/images/add-card.png"),
          bankName: "添加新的银行卡",
          id: 0,
        },
      ],
      payToken: "",
    };
  },
  components: {
    payCardPassWord,
  },
  computed: {
    payAddCard() {
      return localStorage.getItem("payAddCard") || "";
    },
  },
  watch: {
    isShowPayModal() {
      this.isShowPay = this.isShowPayModal;
    },
  },
  created() {
    this.getCardList();
  },
  mounted() {},
  methods: {
    getCardList() {
      getCardList().then((res) => {
        if (res.resCode === 1) {
          this.payCardList = this.payCardList.concat(res.data);
          this.payCardList.forEach((item, index) => {
            if (item.acctNo) {
              item.sliceCard = item.acctNo.slice(item.acctNo.length - 4);
            }
            if (item.defaultCard === 1) {
              this.checkedValue = index;
              this.cardInfo = item;
            }
          });
        } else {
          this.$Message.warning(res.resDesc);
        }
      });
    },

    //选择支付方式
    checkCard(item, index) {
      this.checkedValue = item.id;
      this.payToken = item.payToken;
    },

    cancel() {
      if (this.checkedValue) {
        this.$emit("cancelShowPayModal", false);
      }

      this.$emit("update:isShowPayModal", false);
    },
    // 确认支付
    payConfim() {
      if (!this.checkedValue && this.checkedValue !== 0) {
        this.$Message.warning("请选择支付卡");
        return false;
      }
      if (this.checkedValue == 0) {
        let page2 = this.$router.resolve({
          path: "/member/bankCard",
          query: { page: "pay" },
        });
        // 跳转到pay进行结算

        var page = window.open(page2.href, "_blank");
        var loop = setInterval(() => {
          if (page.closed) {
            console.log("子页面关闭");
            (this.payCardList = [
              {
                bankLogoUrl: require("../../../assets/images/add-card.png"),
                bankName: "添加新的银行卡",
                id: 0,
              },
            ]),
              this.getCardList();
            clearInterval(loop);
          }
        }, 1000);
      } else {
        this.payCardFun();
      }
    },

    getCode() {
      this.payCardFun();
    },

    //积分支付
    payCardFun() {
      const orderInfo = {
        businessCentre: this.businessCentre,
        orderSns: this.orderSns,
        payType: 56,
        payToken: this.payToken,
      };
      doPay(orderInfo).then((res) => {
        if (res.resCode === 1) {
          console.log(JSON.parse(res.data.payData));
          this.cusTraceNo = JSON.parse(res.data.payData).cusTraceNo;
          this.isShowPayCardModal = true;
          this.$Message.success("短信已发送");
          // this.$router.push({ path: "/member/order" });
        } else {
          // 返回不成功
          this.$Message.warning(res.resDesc);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.address-modal {
  .pay_channel_wrapper {
    padding: 10px 18px;
    box-sizing: border-box;
    background: #fff;
  }
  .pay_channel {
    line-height: 45px;
    padding-top: 8px;
    overflow: hidden;
    .pay_channel_icon {
      margin-right: 30px;
      -webkit-transform: translateY(4px);
      -ms-transform: translateY(4px);
      transform: translateY(4px);
    }
    .icons_channel_unselect {
      width: 24px;
      height: 22px;
      background-position: -2px 0;
    }
    .pay_channel_type {
      width: 280px;
      .pay_channel_logo {
        width: 45px;
        font-size: 16px;
        color: #333;
        font-family: Microsoft Yahei;
        margin-right: 5px;
        vertical-align: top;
      }
      .pay_channel_name {
        font-size: 16px;
        color: #333;
        font-family: Microsoft Yahei;
        margin-right: 5px;
        vertical-align: top;
      }
      strong {
        font-size: 14px;
      }
    }
  }

  input[type="radio"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }

  label {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #999;
  }
  input:checked + label {
    background-color: #fe6d32;
    border: 1px solid #fe6d32;
  }
  input:checked + label::after {
    position: absolute;
    content: "";
    width: 5px;
    height: 10px;
    top: 4px;
    left: 8px;
    border: 2px solid #fff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
  }
}
</style>



// WEBPACK FOOTER //
// payListModal.vue?6ffd563f